/*
 * 文件EN: repaymentCheck.js,
 * 文件CN: 商户还款-还款查询,
 * 创建时间: Monday, 6th July 2020 3:12:18 pm,
 * 创建人: yeungxsheng,
 * 联系邮箱: 854427332@qq.com,
 */

import request from '@/plugins/http'

/**
 * @desc 商户还款--还款列表查询 第一个table 主页列表
 * @method GET
 * @param {}
 */
export const getListData = params => {
  return request.get('/merchantRepay/repayInquiry', params)
}

/**
 * @desc 商户还款--还款记录列表查询  第二个table
 * @method GET
 * @param {详细见swagger}
 */
export const getListDataSecond = params => {
  return request.get('/merchantRepay/merRepayRecords', params)
}